import { render } from "./ProjectList.vue?vue&type=template&id=3f7e389a&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=3f7e389a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f7e389a"

export default script